angular.module('gym.integrations', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.integrations', {
    url: '/integrations',
    template: require('templates/gyms/integrations/index.html.slim')
  });
}]);
